import React from 'react';
import {Box} from '@mui/material';
import {
    WpIssueMarkControl,
    type WpIssueMarkControlProps,
    type WpIssueMarkState
} from '@/pages/components/audit/adjustment/adjust/dialogs/basic/common/WpIssueMarkControl';
import {WP_STATUS} from '@/pages/components/audit/adjustment/adjust/dialogs/utils/wpStatusUtils';
import {
    WpCheckSummaryProvider
} from '@/pages/components/audit/adjustment/adjust/dialogs/basic/common/wpCheckSummaryContext';
import {WpCheckAccordion} from '@/pages/components/audit/adjustment/adjust/dialogs/basic/common/WpCheckAccordion';

export interface WpCheckToolbarProps {
    code: string;
    companyId: number;
    annualId: number;
    initialWpStatus?: number | null;
    initialWpIssueRemark?: string | null;
    initialOutstanding?: boolean;
    initialOutstandingRemark?: string | null;
    onIssueMarkChange?: (state: WpIssueMarkState) => void;
    children: React.ReactNode;
    issueMarkProps?: Partial<WpIssueMarkControlProps>;
    /** Optional content left of the accordion (e.g. GL invoice button). */
    leading?: React.ReactNode;
    isCommonMode?: boolean;
    /** Forwarded to WpCheckAccordion — open on first render when true. */
    defaultExpanded?: boolean;
}

export function WpCheckToolbar({
                                   code,
                                   initialWpStatus,
                                   initialWpIssueRemark,
                                   initialOutstanding,
                                   initialOutstandingRemark,
                                   onIssueMarkChange,
                                   children,
                                   issueMarkProps,
                                   leading,
                                   isCommonMode = true,
                                   defaultExpanded = false,
                               }: WpCheckToolbarProps) {
    return (
        <WpCheckSummaryProvider>
            <Box sx={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: 2,
                flexWrap: 'wrap'
            }}>
                <WpIssueMarkControl
                    code={issueMarkProps?.code ?? code ?? ''}
                    defaultMarked={initialWpStatus === WP_STATUS.HAS_ISSUE}
                    defaultRemark={initialWpIssueRemark}
                    defaultOutstanding={initialOutstanding ?? false}
                    defaultOutstandingRemark={initialOutstandingRemark}
                    onChange={onIssueMarkChange}
                    disabled={issueMarkProps?.disabled}
                />
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        gap: leading ? 3.5 : 0,
                        minWidth: 'min-content',
                    }}
                >
                    {leading}
                    <>
                        {isCommonMode && (
                            <WpCheckAccordion
                                defaultExpanded={defaultExpanded}
                                sx={{flex: 1, width: '100%', minWidth: 'min-content'}}
                            >
                                {children}
                            </WpCheckAccordion>
                        )}
                    </>
                </Box>
            </Box>
        </WpCheckSummaryProvider>
    );
}
